export const fromBase64 = (b64string = '') => atob(b64string)
